import {
  AMENITY_RENTALS_URL,
  CIVIC_REC_ACCOUNT_URL,
  EVENTS_PROGRAMMING_URL,
  PARKS_REC_EMAIL,
  PARKS_REC_PHONE,
  PARKS_REC_PHONE_DISPLAY,
  RANCH_CALENDAR_URL,
  REC1_CATALOG_URL,
} from '@shared/ranch-feed';
import {
  HOA_NATIONAL_CALENDAR_URL,
  HOA_NATIONAL_DINING_RESERVATION_URL,
  HOA_NATIONAL_ENCLAVE_MENUS_URL,
  HOA_NATIONAL_PHONE,
  HOA_NATIONAL_PHONE_DISPLAY,
} from '@shared/hoa-national-events';

/**
 * Deep-links into the town's CivicPlus calendar and CivicRec (Rec1).
 * We do not rebuild registration or amenity booking.
 */
export function RanchPortalLinks() {
  return (
    <div>
      <div className="action-row" style={{ marginTop: 10 }}>
        <a className="action-btn" href={RANCH_CALENDAR_URL} target="_blank" rel="noreferrer">
          Town calendar
        </a>
        <a className="action-btn" href={REC1_CATALOG_URL} target="_blank" rel="noreferrer">
          Register on Rec1
        </a>
        <a className="action-btn" href={AMENITY_RENTALS_URL} target="_blank" rel="noreferrer">
          Rent an amenity
        </a>
      </div>
      <p className="ranch-portal-meta">
        <a href={CIVIC_REC_ACCOUNT_URL} target="_blank" rel="noreferrer">
          Civic Rec account
        </a>
        {' · '}
        <a href={EVENTS_PROGRAMMING_URL} target="_blank" rel="noreferrer">
          Events &amp; Programming
        </a>
        {' · '}
        <a href={`mailto:${PARKS_REC_EMAIL}`}>{PARKS_REC_EMAIL}</a>
        {' · '}
        <a href={`tel:${PARKS_REC_PHONE}`}>{PARKS_REC_PHONE_DISPLAY}</a>
      </p>
      <div className="action-row" style={{ marginTop: 10 }}>
        <a className="action-btn" href={HOA_NATIONAL_CALENDAR_URL} target="_blank" rel="noreferrer">
          National calendar
        </a>
        <a className="action-btn" href={HOA_NATIONAL_DINING_RESERVATION_URL} target="_blank" rel="noreferrer">
          Dining reservation
        </a>
        <a className="action-btn" href={HOA_NATIONAL_ENCLAVE_MENUS_URL} target="_blank" rel="noreferrer">
          Enclave menus
        </a>
      </div>
      <p className="ranch-portal-meta">
        Babcock National Member Central ·{' '}
        <a href={`tel:${HOA_NATIONAL_PHONE}`}>{HOA_NATIONAL_PHONE_DISPLAY}</a>
        . Calendar snapshot is in-repo — the live HOA calendar requires a member login.
      </p>
    </div>
  );
}
